import { render } from "./DisplayContents.vue?vue&type=template&id=0294d91f&scoped=true"
import script from "./DisplayContents.vue?vue&type=script&lang=js"
export * from "./DisplayContents.vue?vue&type=script&lang=js"

import "./DisplayContents.vue?vue&type=style&index=0&id=0294d91f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0294d91f"]])

export default __exports__